module.exports = __webpack_public_path__ + "img/1.1bd335e0.png";